import moment from "moment";

export const SUBSUB_DATE_FORMAT = "DD/MM/YYYY HH:mm:ss";

const FUTURE_BORDER_COLOR = "#8b0000";
const FUTURE_LABEL_COLOR = "#ffb3b3";
const EXPIRED_BORDER_COLOR = "#ff2d44";
const DEFAULT_LABEL_COLOR = "rgba(255, 255, 255, 0.72)";

export const parseSubsubDate = (value) => {
  if (!value) {
    return null;
  }

  if (moment.isMoment(value)) {
    return value.isValid() ? value.clone() : null;
  }

  if (value instanceof Date) {
    const parsedDate = moment(value);
    return parsedDate.isValid() ? parsedDate : null;
  }

  if (typeof value === "object" && typeof value.toDate === "function") {
    const parsedTimestamp = moment(value.toDate());
    return parsedTimestamp.isValid() ? parsedTimestamp : null;
  }

  if (typeof value === "string") {
    const trimmedValue = value.trim();
    if (!trimmedValue) {
      return null;
    }

    const displayFormat = moment(trimmedValue, SUBSUB_DATE_FORMAT, true);
    if (displayFormat.isValid()) {
      return displayFormat;
    }

    const genericFormat = moment(trimmedValue);
    return genericFormat.isValid() ? genericFormat : null;
  }

  const parsed = moment(value);
  return parsed.isValid() ? parsed : null;
};

const formatDuration = (diffMs) => {
  const absDiff = Math.abs(diffMs);
  const totalHours = Math.floor(absDiff / (1000 * 60 * 60));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  return `${days}d ${hours}h`;
};

export const getSubsubValidityStatus = (subsub, nowInput = null) => {
  const parsedNow = nowInput ? parseSubsubDate(nowInput) : null;
  const now = parsedNow || moment();
  const validFrom = parseSubsubDate(subsub?.validFrom);
  const expiryDate = parseSubsubDate(subsub?.expiryDate || subsub?.validUntil);

  if (expiryDate && expiryDate.isSameOrBefore(now)) {
    return {
      state: "expired",
      label: `Expired ${formatDuration(expiryDate.diff(now))} ago.`,
      borderStyle: { border: `1px solid ${EXPIRED_BORDER_COLOR}` },
      labelColor: EXPIRED_BORDER_COLOR,
    };
  }

  if (validFrom && validFrom.isAfter(now)) {
    return {
      state: "future",
      label: `Activate in ${formatDuration(validFrom.diff(now))}`,
      borderStyle: { border: `1px solid ${FUTURE_BORDER_COLOR}` },
      labelColor: FUTURE_LABEL_COLOR,
    };
  }

  if (expiryDate && expiryDate.isAfter(now)) {
    return {
      state: "active-expiring",
      label: `Expires in ${formatDuration(expiryDate.diff(now))}`,
      borderStyle: {},
      labelColor: DEFAULT_LABEL_COLOR,
    };
  }

  if (validFrom && validFrom.isSameOrBefore(now)) {
    return {
      state: "active-since",
      label: `Active since ${formatDuration(validFrom.diff(now))} ago.`,
      borderStyle: {},
      labelColor: DEFAULT_LABEL_COLOR,
    };
  }

  return {
    state: null,
    label: null,
    borderStyle: {},
    labelColor: DEFAULT_LABEL_COLOR,
  };
};
